export default {
  colorTheme: {
    colorPrimary: '#001730',
    colorSecondary: '#fd1d18'
  },
  user: {},
  currentTenant: {},
  currentAccount: {
    id: 1,
    name:'POSPORTAL'
  },
  token: null,
  gsk: null,
  survey: true,
  amountAccounts: '',
  amountTenants: '',
  permissions: []
}
